import { useParams } from "react-router-dom";
import { useEffect } from "react";
import FacilityAvailabilityForm from "@/v2/components/facility-availability/FacilityAvailabilityForm";

const EditFacilityAvailability = () => {
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    document.title = "Edit Facility Availability | Admin";
  }, []);

  return (
    <div className="space-y-6">
      <FacilityAvailabilityForm 
        facilityAvailabilityId={id ? parseInt(id) : undefined}
        isEdit={true}
      />
    </div>
  );
};

export default EditFacilityAvailability;
